'use client';

import { usePathname } from 'next/navigation';

import { getArticleType } from '@sola/contentful-model/lib/article.js';
import {
  ArticleCountriesEnum,
  ArticleThemesEnum,
  ArticleTopicsEnum,
  ArticleTypesEnum,
} from '@sola/contentful-model/lib/taxonomy-values.js';
import { ArticleProps, BlockProps } from '@sola/schema/lib/schema.js';

import { ArticleList } from '../../../molecules/article-group/article-list';

export interface ArticleListInsertProps extends BlockProps {
  article?: ArticleProps;
  articleType?: ArticleTypesEnum;
  limit?: number;
  isRelated?: boolean;
}

export const ArticleListInsert: React.FC<ArticleListInsertProps> = ({
  article,
  articleType,
  seoLevel,
  limit = 4,
  isRelated = false,
}) => {
  const pathname = usePathname();

  const determinedArticleType =
    articleType ||
    getArticleType(pathname) ||
    (article?.taxonomyArticleType as ArticleTypesEnum) ||
    ArticleTypesEnum.enum.blogPost;

  if (!determinedArticleType) {
    return null;
  }

  return (
    <section className="component component--no-header">
      <div className="container">
        <ArticleList
          articleType={determinedArticleType}
          topic={article?.taxonomyTopic?.[0] as ArticleTopicsEnum}
          country={article?.taxonomyProgramCountry?.[0] as ArticleCountriesEnum}
          theme={article?.taxonomyArticleTheme?.[0] as ArticleThemesEnum}
          seoLevel={seoLevel}
          excludeContentfulEntryID={article?.contentfulEntryID}
          limit={limit}
          variant={isRelated ? 'related' : 'default'}
          hidePagination
        />
      </div>
    </section>
  );
};
